import { DataSource, DateRangeFilter, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTotalFuelReport extends Layout {
    daterangefilter1: DateRangeFilter;
    sourceFuelTotalsConfigured: DataSource;
    textboxFuelInterfaceId: Textbox;
}
